import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "table__cell-vacation"
}
const _hoisted_2 = { class: "vacation-letter" }

import { vacationTypes } from "@/utils/vacation";
import { VacationItem } from "@/types";

interface Props {
  vacationObj: VacationItem | undefined;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VitaVacationType',
  props: {
    vacationObj: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (__props.vacationObj && _unref(vacationTypes)[__props.vacationObj.type])
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(vacationTypes)[__props.vacationObj.type].letter), 1)
      ]))
    : _createCommentVNode("", true)
}
}

})